import React, { useState, useEffect } from 'react';
import { getErrorConfig } from '../../utils/getQueryErrorMessage';
import { Button, Space } from 'antd';
import { ServerError } from '@src/components/common/Retry/Elements';

export const useErrors = ({
  summaryError,
  sessionTableError,
  eventListError,
  refetchSummary,
  refetchSessionTable,
  refetchEventList,
}) => {
  const [error, setError] = useState<boolean>(false);
  useEffect(() => {
    setError(false);
    if (summaryError || sessionTableError || eventListError) {
      setError(true);
    }
  }, [eventListError, sessionTableError, summaryError]);

  const renderError = () => {
    if (!summaryError && !sessionTableError && !eventListError) return null;

    let error = eventListError;
    let refetch = refetchEventList;
    if (sessionTableError) {
      error = sessionTableError;
      refetch = refetchSessionTable;
    }
    if (summaryError) {
      error = summaryError;
      refetch = refetchSummary;
    }

    const { message: errorMsg, retry: shouldRetry } = getErrorConfig(error);

    return (
      <Space direction="vertical" style={{ alignItems: 'center' }}>
        <ServerError message={errorMsg} />
        {shouldRetry && (
          <Button onClick={refetch} type="primary" ghost>
            Retry
          </Button>
        )}
      </Space>
    );
  };

  return {
    error,
    renderError,
  };
};
